//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ChevronLeft from './ChevronLeft.vue';
import OrderStatus from './OrderStatus.vue';

export default {
  components: {
    ChevronLeft,
    OrderStatus,
  },
  props: {
    order: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      formatters: {
        CZK: new Intl.NumberFormat('cs-CZ', {
          style: 'currency',
          currency: 'CZK',
        }),
        EUR: new Intl.NumberFormat('cs-CZ', {
          style: 'currency',
          currency: 'EUR',
        }),
      },
      loading: false,
    };
  },
  computed: {
    createdAt() {
      return new Date(this.order.date_created.date);
    },
    date() {
      const d = this.createdAt;
      const day = d.getDate();
      const month = d.getMonth() + 1;
      const year = d.getFullYear();
      return `${day}.${month}.${year}`;
    },
    backorderDays() {
      const metaData = this.order.meta_data;
      const found = metaData.find(m => m.key === '_backorder_days');
      if (found && found.value !== '0') return parseInt(found.value);
      return 2;
    },
    sentDate() {
      const d = this.createdAt;
      const days = this.backorderDays;
      d.setDate(d.getDate() + days);
      const day = d.getDate();
      const month = d.getMonth() + 1;
      const year = d.getFullYear();
      return `${day}.${month}.${year}`;
    },
    products() {
      return this.order.line_items;
    },
    total() {
      return this.priceFormatter.format(this.order.total);
    },
    priceFormatter() {
      return this.formatters[this.order.currency];
    },
  },
  methods: {
    cancelOrder() {
      this.loading = true;
      const data = {
        action: 'vue_cancel_order',
        id: this.order.id,
      };
      $.ajax({
        type: 'POST',
        url: wc_add_to_cart_params.ajax_url,
        data,
        success: () => {
          this.loading = false;
          this.$emit('update', {
            id: this.order.id,
            update: { status: 'cancelled' },
          });
          this.$emit('close');
        },
        error: () => {},
      });
    },
  },
};



// WEBPACK FOOTER //
// ./scripts/vue/auth/partials/OrderDetail.vue